// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinTwoToneSvg from "@fishx/icons-svg/es/asn/PushpinTwoTone";
import FishxIcon from '../components/FishxIcon';

var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinTwoToneSvg
  }));
};

PushpinTwoTone.displayName = 'PushpinTwoTone';
export default React.forwardRef(PushpinTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PushpinTwoTone.js
// module id = 3942
// module chunks = 0